import { apiHandlerWithError } from 'api';

import { formatBody } from 'api/utils';

export default async function createUser(body) {
  return await apiHandlerWithError.post('users', formatBody(body));
}
